/* eslint-disable no-magic-numbers */

import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import { GET_REPORTING_FLAGS_RESPONSE } from './fixtures';

export const reportingFlagsHandlers = [
  http.get(`*/${API_PATH}/:companyId`, () =>
    HttpResponse.json(GET_REPORTING_FLAGS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
];
